
<template>
  <div class="project-settings-description-templates-template">
    <i class="ddi ddi-saved-replies" />
    <span class="project-settings-description-templates-template__title">{{ title }}</span>
    <div>
      <dd-icon-button 
        :is-disabled="disabled" 
        icon="edit"
        type="rounded"
        size="medium"
        color="grey"
        @click="edit" 
      />
      <dd-icon-button 
        :is-disabled="disabled" 
        danger
        icon="trash"
        type="rounded"
        size="medium"
        color="grey"
        @click="remove" 
      />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjectSettingsDescriptionTemplatesTemplate',

  props: {
    index: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['edit', 'remove'],
  methods: {
    edit(): void {
      this.$emit('edit', this.index)
    },
    remove(): void {
      this.$emit('remove', this.index)
    },
  },
})
</script>

<style lang="scss">
.project-settings-description-templates-template {
  display: flex;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: $border--solid-extra-light;
  }

  > i {
    color: var(--color-text-third);
  }

  &__title {
    margin-left: 10px;
    @include lettering--p;
    font-weight: $bold;
  }

  > div {
    display: flex;
    margin-left: auto;

    > :last-child {
      margin-left: 8px;
    }
  }
}
</style>
